import type { CustomFlowbiteTheme } from 'flowbite-react';

export const sidebarTheme: CustomFlowbiteTheme['sidebar'] = {
  root: {
    base: 'h-full',
    collapsed: {
      on: 'w-16',
      off: 'w-64',
    },
    inner:
      'h-full overflow-y-auto overflow-x-hidden rounded bg-white px-3 py-4 border-r border-titan-night-50',
  },
  collapse: {
    button:
      'group flex w-full items-center rounded-lg p-2 text-base font-normal text-titan-night-900 transition duration-(--duration-fast) hover:bg-titan-night-100',
    icon: {
      base: 'h-6 w-6 text-titan-night-500 transition duration-(--duration-fast) group-hover:text-titan-night-900',
      open: {
        off: '',
        on: 'text-titan-night-900',
      },
    },
    label: {
      base: 'ml-3 flex-1 whitespace-nowrap text-left',
      icon: {
        base: 'h-6 w-6 transition delay-0 ease-standard',
        open: {
          on: 'rotate-180',
          off: '',
        },
      },
    },
    list: 'space-y-2 py-2',
  },
  cta: {
    base: 'mt-6 rounded-lg bg-titan-night-100 p-4',
    color: {
      blue: 'bg-titan-blue-50',
      dark: 'bg-titan-night-50',
      failure: 'bg-titan-folly-50',
      gray: 'bg-titan-night-50',
      green: 'bg-green-50',
      light: 'bg-titan-night-50',
      red: 'bg-titan-folly-50',
      purple: 'bg-purple-50',
      success: 'bg-green-50',
      yellow: 'bg-titan-yellow-50',
      warning: 'bg-titan-yellow-50',
    },
  },
  item: {
    base: 'flex items-center justify-center rounded-lg p-2 text-base font-normal text-titan-night-900 hover:bg-titan-night-100',
    active: 'bg-titan-night-100',
    collapsed: {
      insideCollapse: 'group w-full pl-8 transition duration-(--duration-fast)',
      noIcon: 'font-bold',
    },
    content: {
      base: 'flex-1 whitespace-nowrap px-3',
    },
    icon: {
      base: 'h-6 w-6 shrink-0 text-titan-night-500 transition duration-(--duration-fast) group-hover:text-titan-night-900',
      active: 'text-titan-night-700',
    },
    label: '',
    listItem: '',
  },
  items: {
    base: '',
  },
  itemGroup: {
    base: 'mt-4 space-y-2 border-t border-titan-night-200 pt-4 first:mt-0 first:border-t-0 first:pt-0',
  },
  logo: {
    base: 'mb-5 flex items-center pl-2.5',
    collapsed: {
      on: 'hidden',
      off: 'self-center whitespace-nowrap text-xl font-semibold',
    },
    img: 'mr-3 h-6 sm:h-7',
  },
};
